<template>
  <v-expansion-panels 
    data-component-id="reprise-filters"
    v-model="panels"
    multiple
    flat
    rounded
    :disabled="!hasData"
    class="
      z4
      mt-4
    "
  >
    <v-expansion-panel
      class="
        rounded-lg
        outline-1
      "
    >
      <v-expansion-panel-header 
        color="grey lighten-5"
        class="
          pa-3 rounded-b-0
          font-weight-bold black--text outline-1
        "
        style="min-height: auto;"
      >
        Reprises
      </v-expansion-panel-header>
      <v-expansion-panel-content class="px-3">
        <SessionsFiltersPanel :sessions="sessions" />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel
      class="
        rounded-lg
        outline-1
      "
    >
      <v-expansion-panel-header 
        color="grey lighten-5"
        class="
          pa-3 rounded-b-0
          font-weight-bold black--text outline-1
        "
        style="min-height: auto;"
      >
        Chevaux
      </v-expansion-panel-header>
      <v-expansion-panel-content class="px-3">
        <HorsesFiltersPanel :horses="horses" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api';
import store from '@/store';

import SessionsFiltersPanel from './SessionsFiltersPanel.vue';
import HorsesFiltersPanel from './HorsesFiltersPanel.vue';

export default {
  name: 'RepriseFilters',
  components: {
    SessionsFiltersPanel,
    HorsesFiltersPanel
  },
  setup () {
    const horses = computed(() => store.state.horses);
    const sessions = computed(() => store.getters.dailySessions);
    const hasData = computed(() => (sessions.value.length && (!store.state.isLazyLoaded.horses || horses.value.length)));
    
    const panels = ref(hasData.value ? [0, 1] : []);

    watch(hasData, (val) => {
      panels.value = val ? [0, 1] : [];
    });

    return { panels, horses, sessions, hasData };
  }
};
</script>

<style>
[data-component-id="reprise-filters"] {
  .v-expansion-panel-content__wrap {
    padding: 0;
  }
}
</style>
